<template>
    <div class="map" id="map">
           <img src="@/static/music.png" :class="music ? 'music zhuan' : 'music'" @click="stopmusic" alt="" />
 <audio id="audio" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
        <div class="map-bg" id="mapbg">
            <img src="../static/map.jpg" class="themap" alt="">
            <img src="../static/star.png" class="star" alt="">
            <img src="../static/tips1.png" class="tips1" @click="opendetails(1)" v-show="tips1" alt="">
            <img src="../static/tips2.png" class="tips2" @click="opendetails(2)" v-show="tips2" alt="">
            <img src="../static/tips3.png" class="tips3" @click="opendetails(3)" v-show="tips3" alt="">
            <img src="../static/tips4.png" class="tips4" @click="opendetails(4)" v-show="tips4" alt="">
            <img src="../static/tips5.png" class="tips5" @click="opendetails(5)" v-show="tips5" alt="">
            <img src="../static/tips6.png" class="tips6" @click="opendetails(6)" v-show="tips6" alt="">
            <img src="../static/tips7.png" class="tips7" @click="opendetails(7)" v-show="tips7" alt="">
            <img src="../static/tips8.png" class="tips8" @click="opendetails(8)" v-show="tips8" alt="">

            <!-- <img src="../static/back.png" class="back" @click="backletter" alt=""> -->

                <div class="icon-box" v-show="but">
        <img src="../static/letter_icon1.png" class="icon3" @click="tohyl" alt="">
        <img src="../static/letter_icon2.png" class="icon2" alt="" @click="showgry = true">
        <img src="../static/letter_icon3.png" class="icon1" alt="" @click="tofyt">
        <a href="https://www.720yun.com/vr/4b3jtpuakv0" target="_blank"> <img src="../static/letter_icon5.png"
            class="icon5" alt=""></a>
      </div>

          <div class="gry_box" v-if="showgry">
      <img src="../static/gry_bg.jpg" class="gry_bg" alt="">
      <van-swipe class="my-swipe" :autoplay="6000" indicator-color="white">
        <van-swipe-item><img src="../static/gry_1.png" class="gry" alt=""></van-swipe-item>
        <van-swipe-item><img src="../static/gry_2.png" class="gry" alt=""></van-swipe-item>
        <van-swipe-item><img src="../static/gry_3.png" class="gry" alt=""></van-swipe-item>
        <van-swipe-item><img src="../static/gry_4.png" class="gry" alt=""></van-swipe-item>
        <van-swipe-item><img src="../static/gry_5.png" class="gry" alt=""></van-swipe-item>
        <van-swipe-item><img src="../static/gry_6.png" class="gry" alt=""></van-swipe-item>
        <van-swipe-item><img src="../static/gry_7.png" class="gry" alt=""></van-swipe-item>
        <van-swipe-item><img src="../static/gry_8.png" class="gry" alt=""></van-swipe-item>
        <van-swipe-item><img src="../static/gry_9.png" class="gry" alt=""></van-swipe-item>
        <van-swipe-item><img src="../static/gry_10.png" class="gry" alt=""></van-swipe-item>
      </van-swipe>

      <img src="../static/back.png" class="back" @click="showgry = false" alt="">
    </div>
        </div>

        <Details v-if="ifDetails" class='details' @child-event="closedetails" :id="id"></Details>
    </div>
</template>

<script>
import Details from './details.vue';
export default {
      components: {
        Details
    },
    data() {
        return {
            tips1:false,
            but:false,
            tips2:false,
            tips3:false,
            tips4:false,
            tips5:false,
            tips6:false,
            tips7:false,
            tips8:false,
            ifDetails:false,
            id:'',
            music:true,
            showgry: false,
         
        }
    },
    methods: {
         tofyt() {
      let audio = document.getElementById("audio");
      window.sessionStorage.setItem("time", audio.currentTime);
      window.sessionStorage.setItem("music", this.music);
       window.sessionStorage.setItem("iffirst", "true");
      this.$router.push("fyt")
    },
    tohyl() {
      let audio = document.getElementById("audio");
      window.sessionStorage.setItem("time", audio.currentTime);
      window.sessionStorage.setItem("music", this.music);
      window.sessionStorage.setItem("iffirst", "true");
      this.$router.push("hyl")
    },
         closedetails() {
            // document.getElementById("scene").style=""
         
            this.ifDetails = false

        },
        backletter(){
             let audio = document.getElementById("audio");
            window.sessionStorage.setItem("time", audio.currentTime);
            window.sessionStorage.setItem("music", this.music);
            window.sessionStorage.setItem("iffirst", "true");
          this.$router.push("letter")
        },
          stopmusic() {
            let audio = document.getElementById("audio");
            if (this.music == true) {
                this.music = false;
                audio.pause();

            } else {
                this.music = true;
                // audio.volume = 0.2;
                audio.play();
            }
        },
           opendetails(a) {
            // document.getElementById("scene").style="overflow: hidden;height: 100vh;"
            if (a == 1) {
                this.id = 1817146
            } else if (a == 2) {
                this.id = 1819175
            } else if (a == 3) {
                this.id = 1827116
            } else if (a == 4) {
                this.id = 1823353
            } else if (a == 5) {
                this.id = 1821401
            } else if (a == 6) {
                this.id = 1831968
            } else if (a == 7) {
                this.id = 1825931
            } else if (a == 8) {
                this.id = 1829649
            } else if (a == 9) {
                this.id = 1698326   //缺
            } else if (a == 10) {
                this.id = 1698327   //缺
            } else if (a == 11) {
                this.id = 1698327   //缺
            }

            this.ifDetails = true
          

        },
               tobottom() {
          
      var home = document.getElementById("map");
      var homebg = document.getElementById("mapbg");
      var scrollDistance = 1.5;
      var height = homebg.offsetHeight;
      var screenHeight = window.innerHeight;
      // console.log('相差：', height - screenHeight);

      // console.log('高', height);
      // console.log('屏幕：', screenHeight);
      // console.log('滚轮高度:', home.scrollTop);
      var timer = setInterval(() => {
     
          home.scrollTop = home.scrollTop + scrollDistance
          if (home.scrollTop >= height - screenHeight-1) {
            this.but = true
          console.log("到底了");
          clearTimeout(timer);
          
        }
      }, 10)

    },
    },
    mounted() {

         let audio = document.getElementById("audio");

            if (window.sessionStorage.getItem("music") == "false") {
                this.music = false
                audio.pause();
            } else {


                if (window.sessionStorage.getItem("time") != "null") {

                    audio.currentTime = window.sessionStorage.getItem("time")
                    // audio.play()
                }

                audio.play()
            }
            if (window.sessionStorage.getItem("iffirst") == "true") {
                this.tips1=true
                this.tips2=true
                this.tips3=true
                this.tips4=true
                this.tips5=true
                this.tips6=true
                this.tips7=true
                this.tips8=true
                // this.but=true
                this.tobottom()
            }else{
                   setTimeout(() => {
            this.tips1=true
        }, 1500);
          setTimeout(() => {
            this.tips3=true
        }, 2500);
          setTimeout(() => {
            this.tips2=true
        }, 3500);
          setTimeout(() => {
            this.tips4=true
        }, 4500);
          setTimeout(() => {
            this.tips5=true
        }, 5500);
          setTimeout(() => {
            this.tips6=true
        }, 6500);
          setTimeout(() => {
            this.tips7=true
        }, 7500);
          setTimeout(() => {
            this.tips8=true
        }, 8500);
         setTimeout(() => {
            this.tobottom()
        }, 9500);
            }
     
    },
}
</script>

<style lang="less" scoped>
.map {
        width: 100%;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
     .music {
        position: fixed;
        top: 15px;
        right: 15px;
        width: 40px;
        z-index: 3;
        transform: rotate(250deg);

        &.zhuan {
            animation: turn 2s linear infinite;

            @keyframes turn {
                0% {
                    -webkit-transform: rotate(0deg);
                }

                25% {
                    -webkit-transform: rotate(90deg);
                }

                50% {
                    -webkit-transform: rotate(180deg);
                }

                75% {
                    -webkit-transform: rotate(270deg);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                }
            }
        }
    }
    .map-bg {
        position: relative;
        .back{
            position: fixed;
            left: 0;
            bottom: 0;
            width: 60%;
            left: 50%;
            margin-left: -30%;
        }


      .icon1 {
        position: absolute;
        bottom: 20px;
        left: 30px;
        width: 80px;
        margin-bottom: 14px;

      }
       .icon2 {
        position: absolute;
        bottom: 20px;
        left: 115px;
        width: 70px;
        margin-bottom: 15px;

      }
       .icon3 {
        position: absolute;
        bottom: 20px;
        left: 200px;
        width: 75px;
        margin-bottom: 14px;

      }
       .icon5{
        position: absolute;
        bottom: 20px;
        left: 290px;
        width: 55px;
        margin-bottom: 5px;

      }


        .themap {
            width: 100%;
            display: block;
        }

        .star {
            position: absolute;
            width: 173px;
            top: 255px;
            left: 70px;
            animation: an-hometop 2s ease-out 1 normal;

            @keyframes an-hometop {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }
        }

        .tips1 {
            position: absolute;
            width: 137px;
            top: 275px;
            right: 5px;
              animation: an-tips1 2s ease-in 1 normal;

            @keyframes an-tips1 {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }
        }

        .tips2 {
            position: absolute;
            width: 129.5px;
            top: 240px;
            right: 30px;
             animation: an-tips2 2s ease-in 1 normal;

            @keyframes an-tips2 {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }
        }

        .tips3 {
            position: absolute;
            width: 103px;
            top: 305px;
            right: 136px;
             animation: an-tips3 2s ease-in 1 normal;

            @keyframes an-tips3 {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }
        }

        .tips4 {
            position: absolute;
            width: 116px;
            top: 235px;
            left: 85px;
             animation: an-tips4 2s ease-in 1 normal;

            @keyframes an-tips4 {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }
        }

        .tips5 {
            position: absolute;
            width: 126px;
            top: 275px;
            left: 35px;
             animation: an-tips5 2s ease-in 1 normal;

            @keyframes an-tips5 {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }

        }

        .tips6 {
            position: absolute;
            width: 92px;
            top: 345px;
            left: 0px;
             animation: an-tips6 2s ease-in 1 normal;

            @keyframes an-tips6 {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }

        }

        .tips7 {
            position: absolute;
            width: 131px;
            top: 405px;
            left: 0px;
             animation: an-tips7 2s ease-in 1 normal;

            @keyframes an-tips7 {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }

        }

        .tips8 {
            position: absolute;
            width: 130px;
            top: 580px;
            left: 155px;
             animation: an-tips8 2s ease-in 1 normal;

            @keyframes an-tips8 {
                0% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }

        }

        .but1{
            position: absolute;
            width: 84px;
            bottom: 40px;
            left: 40px;
              animation: thebut 1.5s linear infinite;

        @keyframes thebut {
            0% {
                transform: scale(1);
            }

            50% {
                transform: scale(0.9);
            }

            100% {
                transform: scale(1);
            }
        }
        }
         .but2{
            position: absolute;
            width: 75px;
            bottom: 40px;
            left: 150px;
              animation: thebut 1.5s linear infinite;

        @keyframes thebut {
            0% {
                transform: scale(1);
            }

            50% {
                transform: scale(0.9);
            }

            100% {
                transform: scale(1);
            }
        }
        }
         .but3{
            position: absolute;
            width: 76px;
            bottom: 40px;
            left: 260px;
              animation: thebut 1.5s linear infinite;

        @keyframes thebut {
            0% {
                transform: scale(1);
            }

            50% {
                transform: scale(0.9);
            }

            100% {
                transform: scale(1);
            }
        }
        }
         .gry_box {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    // background: url("../static/gry_bg.png") no-repeat;
    // background-size: 100% 100%;
    width: 100%;
    height: 100vh;

    .gry_bg {
      position: absolute;
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;
      z-index: -1;
    }

    .my-swipe {
      z-index: 2;
      position: relative;
      top: 30px;
      left: 35px;
      width: 300px;
      height: 533px;
      // .van-swipe__indicators {
      //   left: 40%;
      // }

      .gry {
        width: 300px;
        height: 533px;
      }


    }

    .back {
      position: absolute;
      left: 0;
      bottom: 10px;
      width: 60%;
      left: 50%;
      margin-left: -30%;
    }
  }
    }
       .details {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        background-color: #fff;
        z-index: 10;
        overflow: hidden;
        overflow-y: scroll;
        // padding-bottom: 60px;
    }
}
</style>
